import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import {HeadingTypography} from 'patient-ping-remedy/packages/typography';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.small};
  padding: ${sizes.medium};
`;

export const InlineButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${sizes.xSmall};
`;

export const HeaderStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xxSmall};
`;

// Explicit 2.4rem/weight overrides Remedy's inherited DisplaySmallTypography (Figma heading/large).
export const HeaderTitle = styled(HeadingTypography)`
  font-size: 2.4rem;
  line-height: 3.2rem;
  font-weight: 400;
  color: ${colors.charcoal};
  margin-bottom: 0;
`;

// Explicit size overrides the inherited DisplaySmallTypography so the sub-line reads as body/large.
export const ContextTriggeredBy = styled.span`
  font-size: ${fontSize.standard};
  line-height: 2.1rem;
  font-weight: normal;
  color: ${colors.gray5};
`;

export const InputFieldSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xxSmall};
`;

export const NewNoteLabel = styled.label`
  display: block;
  font-size: ${fontSize.standard};
  line-height: 2.4rem;
  font-weight: normal;
  color: ${colors.gray5};
`;

export const NoteTextarea = styled.textarea`
  width: 100%;
  min-height: 9rem;
  padding: ${sizes.xSmall};
  border: 1px solid ${colors.gray3};
  border-radius: ${sizes.xSmall};
  font-family: inherit;
  font-size: ${fontSize.standard};
  line-height: 2.4rem;
  color: ${colors.charcoal};
  resize: vertical;
  box-sizing: border-box;

  &::placeholder {
    color: ${colors.gray4};
  }

  &:focus-visible {
    outline: 2px solid ${colors.blue4};
    outline-offset: 2px;
  }
`;

export const Divider = styled.hr`
  margin: 0;
  border: none;
  border-top: 1px solid ${colors.gray2};
`;

export const NotesHeader = styled.h3`
  margin: 0;
  padding-top: 1.6rem;
  font-size: ${fontSize.small};
  font-weight: 600;
  line-height: 1.95rem;
  letter-spacing: 0.032rem;
  text-transform: uppercase;
  color: ${colors.gray5};
`;

export const NotesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

// gap:0 — interior spacing comes from the content/meta padding-tops, not a flex gap.
export const NoteBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid ${colors.gray2};
  border-radius: 0.8rem;
  padding: 1.2rem 1.4rem;
`;

// Rendered note content (from the stored JSONContent), above the meta row. Keeps the
// `p { margin: 0 }` reset so the generateHTML paragraph output doesn't add vertical margins.
export const NoteContent = styled.div`
  padding-top: 0.4rem;
  font-size: ${fontSize.standard};
  font-weight: normal;
  line-height: 1.8rem;
  color: ${colors.charcoal};

  p {
    margin: 0;
  }
`;

export const NoteMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  padding-top: 0.8rem;
`;

export const NoteAuthor = styled.span`
  font-size: ${fontSize.small};
  font-weight: normal;
  color: ${colors.gray5};
`;

export const Separator = styled.span`
  font-size: ${fontSize.small};
  color: ${colors.gray5};
`;

export const NoteDate = styled.span`
  font-size: ${fontSize.small};
  color: ${colors.gray5};
`;

export const EmptyState = styled.div`
  padding: ${sizes.small} 0;
  color: ${colors.gray5};
`;
